<div class="panel per-maand">
	<div class="panel-header">
		<div class="column title">
			<h2>
				<span>Piramide per maand</span>
				<app-icon
					name="info"
					color="primary-1"
					hoverColor="primary-2"
					size="small"
					[appTooltip]="maandTooltip"
					data-princexml-ignore
					data-html2canvas-ignore
				></app-icon>
			</h2>
			<div class="subtitle">Niet cumulatief schooljaar {{ schooljaar() }}</div>
		</div>
		<div class="toggle" data-princexml-ignore data-html2canvas-ignore>
			<app-toggle-button [checked]="toonAfgeslotenLessen()" (toggled)="toonAfgeslotenLessen.set($event)" [after]="true">
				Toon datavolledigheid (%)
			</app-toggle-button>
		</div>
	</div>
	<ng-template #maandTooltip>
		<div class="tooltip">
			<h4>Aanwezigheidspiramide per maand</h4>
			<p>
				Toont verdeling van leerlingen over drie interventielagen van het piramideraamwerk (MD-MTSS-model) op basis van hun
				aanwezigheidspercentages per maand binnen het gekozen schooljaar.
			</p>
			<ol>
				@for (laag of interventielagen; track laag) {
					<li>{{ laag }}: {{ interventielaagDetails[laag] }}</li>
				}
			</ol>
		</div>
	</ng-template>

	<div class="panel-content">
		<app-vbar-series
			[partitions]="maandPartitions()"
			[style]="Style.PLANE"
			[barHeight]="afgeslotenLessen() ? 310 : 392"
			[barWidth]="barWidth()"
			[paddingTop]="0"
			[paddingBottom]="25"
			textAlign="middle"
		></app-vbar-series>
		@if (afgeslotenLessen(); as metricsData) {
			<app-metrics-series [metrics]="metricsData" [barWidth]="barWidth()"></app-metrics-series>
			<div class="datavolledigheid-info">Percentage lessen met ingevoerde presentie waarop de schoolaanwezigheid is gebaseerd.</div>
		}
	</div>
</div>
